export default "__VITE_ASSET__892333eb__"